import React from "react";
import PropTypes from "prop-types";

function TextInput({
  id,
  label,
  name,
  type,
  value,
  placeholder,
  onChange,
  error = "",
  disabled = false,
  changeColor = false,
  fontSize,
  width,
  min,
  maxLength,
}) {
  let invalidT = "form-control";
  if (error.length > 0) {
    invalidT += " is-invalid";
  }

  const color = changeColor ? "#000" : "#fff";

  const labelElement =
    label !== "" ? (
      <label
        className="lead mb-2"
        htmlFor={id}
        style={{ color, margin: "2px", fontSize }}
      >
        {label}
      </label>
    ) : null;

  return (
    <div className="form-group">
      {labelElement}

      <input
        id={id}
        type={type}
        onChange={onChange}
        name={name}
        className={invalidT}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        style={{ width }}
        min={min}
        maxLength={maxLength}
      />

      <div className="invalid-feedback">{error}</div>
    </div>
  );
}

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default TextInput;
